import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
class AccountAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'Auth';
  controllerName = 'accounts';

  /**
   * Lấy token làm việc
   * Tham số gồm sid, tenant_id/database_id (tùy tình huống có gì truyền đó)
   * tbngoc 06.10.2022: Sửa truyền bằng param và lấy cả tenant_id và database_id
   */
  async getToken(payload) {
    const ip = await this.getFingerPrint();
    let request = {
      url: [this.getAPIUrl(), '/token'].join(''),
      data: payload,
      headers: {
        'ms-mimosa-device-id': ip,
      },
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy token làm việc
   * Tham số gồm sid, tenant_id/database_id (tùy tình huống có gì truyền đó)
   */
  async getTokenNewTenant({databaseId, tenantId}) {
    const ip = await this.getFingerPrint();
    let request = {
      url: [this.getAPIUrl(), 'tokenNewTenant', tenantId, databaseId].join('/'),
      headers: {
        'ms-mimosa-device-id': ip,
      },
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu cho popup chọn dữ liệu làm việc
   */
  getTenants() {
    let request = {
      url: [this.getAPIUrl(), '/tenants'].join(''),
      params: param,
      withCredentials: true,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Đăng xuất
   */
  async logout() {
    const ip = await this.getFingerPrint();
    let request = {
      url: [this.getAPIUrl(), '/logout'].join(''),
      isCheckExpiredToken: false,
      headers: {
        'ms-mimosa-device-id': ip,
      },
    };

    return httpClient.getAsync(request);
  }

  // /**
  //  * Lấy thông tin phân quyền theo chi nhánh
  //  * Nếu không truyền thì sẽ đùng chi nhánh trong context
  //  */
  // getPermission(orgId) {
  // 	var url = [this.getAPIUrl(), 'permission'];
  // 	if (orgId) {
  // 		url.push(orgId);
  // 	}
  // 	let request = {
  //         url: url.join('/'),
  // 	};

  // 	return httpClient.getAsync(request);
  // }

  // /**
  //  * Đăng xuất khỏi ứng dụng
  //  */
  // logoff() {
  // 	let request = {
  //         url: [this.getAPIUrl(), 'logoff'].join('/'),
  // 	};

  // 	return httpClient.postAsync(request);
  // }

  /**
   * Đăng nhập
   */
  loginCode(model) {
    let request = {
      url: [this.getAPIUrl(), 'login-code'].join('/'),
      data: model,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Đăng nhập dùng code
   */
  async loginCallback(model) {
    const ip = await this.getFingerPrint();
    let request = {
      url: [this.getAPIUrl(), 'login-callback'].join('/'),
      data: model,
      isCheckExpiredToken: false,
      headers: {
        'ms-mimosa-device-id': ip,
      },
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy lại thông tin đăng nhập
   */
  async loginInfo(model) {
    const ip = await this.getFingerPrint();
    let request = {
      url: [this.getAPIUrl(), 'login-info'].join('/'),
      data: model,
      headers: {
        'ms-mimosa-device-id': ip,
      },
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy context theo sid khi đăng nhập vào từ amis
   */
  getContext(param) {
    let queryString = qs.stringify(param);
    let request = {
      url: [this.getAPIUrl(), '/context?', queryString].join(''),
    };

    return httpClient.getAsync(request);
  }

  /**
   * Cập nhật ngày tắt thông báo
   * ntloc 1.12.2022
   */
  updateSubscriberCloseWarning(param) {
    let request = {
      url: this.getAPIUrl() + '/updateSubsriberCloseWarning',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Cập nhật ngày tắt thông báo ở top
   */
  updateSubscriberCloseWarningTop(param) {
    let request = {
      url: this.getAPIUrl() + '/updateSubsriberCloseWarningTop',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Cập nhật ngày đọc notify
   * ntloc 1.12.2022
   */
  updateSubsriberReadNotify(param) {
    let request = {
      url: this.getAPIUrl() + '/updateSubsriberReadNotify',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  updateFirstLogin(param) {
    let request = {
      url: [this.getAPIUrl(), 'update-first-login'].join('/'),
      data: param,
    };
    return httpClient.postAsync(request);
  }

  UpdateLoginCount(param) {
    let request = {
      url: [this.getAPIUrl(), 'update-login_count'].join('/'),
      data: param,
    };
    return httpClient.postAsync(request);
  }
  // Hàm lấy thông tin hệ điều hành
  getOSInfo() {
    const userAgent = navigator.userAgent;
    let osName = 'Unknown OS';
    let osVersion = '';

    if (userAgent.includes('Windows')) {
      osName = 'Windows';
      osVersion = userAgent.match(/Windows NT \d+\.\d+/)?.[0] || '';
    } else if (userAgent.includes('Mac OS')) {
      osName = 'macOS';
      osVersion = userAgent.match(/Mac OS X \d+_\d+/)?.[0] || '';
    } else if (userAgent.includes('Linux')) {
      osName = 'Linux';
      osVersion = userAgent.match(/Linux \d+/)?.[0] || '';
    }

    return {osName, osVersion};
  }

  // Hàm lấy thông tin độ phân giải màn hình
  getScreenResolution() {
    return `${window.screen.width}x${window.screen.height}`;
  }

  // Hàm lấy múi giờ
  getTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  // Hàm chuyển thông tin thành Base64
  encodeBase64(data) {
    return btoa(unescape(encodeURIComponent(data)));
  }

  /**
   * Hàm lấy chuỗi định danh thông tin thiết bị đăng nhập
   * @returns chuỗi base64 thông tin thiết bị
   * Created by ntda 01/11/2024
   * ptthuy2 06.03.2025: sửa lại lấy theo visitorID của fingerprintJS
   */
  getDeviceId() {
    // const osInfo = this.getOSInfo();
    // const resolution = this.getScreenResolution();
    // const timezone = this.getTimezone();
    // const deviceInfo = `${osInfo.osName} ${osInfo.osVersion} ${resolution} ${timezone}`;
    // const deviceId = this.encodeBase64(deviceInfo);
    return this.getFingerPrint();
  }

  async getFingerPrint() {
    const fp = await FingerprintJS.load(); // Chờ FingerprintJS load
    const result = await fp.get(); // Lấy kết quả sau khi load xong
    return result.visitorId;
  }
}

export default new AccountAPI();
